import { createContext } from 'react';
import { AppMessage, AppMessageMode } from './types';

export interface AppMessagingContextType {
  mode: AppMessageMode;
  /**
   * Child mode only: true once the shell's `init` message has been received.
   * Until then the child's own URL is not authoritative and must not be
   * reported upward (specs/016-global-nav-venue-sync/contracts/shell-app-messaging.md).
   * Always false in parent mode.
   */
  isInitialised: boolean;
  send: (message: AppMessage) => void;
  onMessage: (callback: (message: AppMessage) => void) => () => void;
  registerIframe: (id: string, iframe: HTMLIFrameElement, origin?: string) => void;
  unregisterIframe: (id: string) => void;
  sendToChild: (childId: string, message: AppMessage) => void;
  broadcastToChildren: (message: AppMessage) => void;
}

export const AppMessagingContext = createContext<AppMessagingContextType | undefined>(undefined);
